<template lang="pug">
    crud-data-table.mx-5(
        :headers="headers" 
        :service="service" 
        :filters="filters" 
        @show="$router.push('/purchase_tax_documents/'+$event)"
        @select="selected = $event"
        :deleteButton="() => false"
        noActions
        checkable
        ref="refCrudDTPaid"
        )
</template>

<script>
import { mapActions } from 'vuex'
import PchInvoiceHeaders from './PchInvoiceHeaders'
import PchInvoiceFilters from './PchInvoiceFilters'
import PchInvoiceDTService from '@/services/api/purchaseInvoice'
import { CrudDataTable } from '@/components/reusable_components'
import ProviderService from '@/services/api/provider'

export default {
    name: 'purchase-invoice-paid',
    props: {},
    data: function(){
        return {
            headers: PchInvoiceHeaders,
            service: PchInvoiceDTService,
            filters: PchInvoiceFilters,
        }
    },
    computed: {},
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        //-
        setFilterOptions(index, options) {
            this.filters[index].options = options
        },
        // - 0
        mapProviderToFilter: ({ business_name, id }) => ({
            text: business_name,
            value: id,
        }),
    },
    watch: {},
    components: {
        'crud-data-table': CrudDataTable,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    async beforeMount() {
        this.setFilterOptions(
            0,
            (await ProviderService.fetchAll()).map(this.mapProviderToFilter)
        )
    },
    mounted: function(){
        this.setTitleTopBar( 'Listado documentos por pagar' ) 
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>